import React, { useState } from "react";
import { connect } from "react-redux";
import { createAward } from "./actions";



const NewAwardForm = ({ awards = [], onCreatePressed }) => {

    const [name, setName] = useState('');
    const [orgnization, setOrgnization] = useState('');
    const [issueDate, setIssueDate] = useState('');
    const [description, setDescription] = useState('');
    const [file, setFile] = useState('');

    const saveDetails = () => {
        onCreatePressed({ name, orgnization, issueDate, description, file });
        setName('');
        setOrgnization('');
        setIssueDate('');
        setDescription('');
        setFile('');
    }

    const handleFileChange = (e) => {
        setFile(e.target.files[0]);
    }

    return (
        <div className="border rounded bg-light p-3 m-2">
            <div style={{ display: 'flex', justifyContent: 'start', gap: '10px', marginBottom: '10px' }}>
                <div>
                    <label style={{ margin: '0', padding: '0' }} htmlFor="position">Award/Achievement/Certification</label>
                    <input
                        className="form-control"
                        type="text"
                        placeholder="Certification/Achievement Title"
                        value={name}
                        onChange={e => setName(e.target.value)}
                        name="name"
                        style={{ padding: '7px' }}
                    />
                </div>
                <div>
                    <label style={{ margin: '0', padding: '0' }} htmlFor="position">Orgnization Name</label>
                    <input
                        className="form-control"
                        type="text"
                        placeholder="Organization"
                        value={orgnization}
                        onChange={e => setOrgnization(e.target.value)}
                        name="orgnization"
                        style={{ padding: '7px' }}
                    />
                </div>
                <div>
                    <label style={{ margin: '0', padding: '0' }} htmlFor="position">Issue Date</label>
                    <input
                        className="form-control"
                        type="date"
                        placeholder="Issue Date"
                        value={issueDate}
                        onChange={e => setIssueDate(e.target.value)}
                        name="issueDate"
                        style={{ padding: '5px' }}
                    />
                </div>
            </div>
            <div style={{ marginBottom: '10px' }}>
                <label style={{ margin: '0', padding: '0' }} htmlFor="position">Upload Certification</label>
                <input
                    className="form-control"
                    style={{ padding: '5px' }}
                    onChange={handleFileChange} type="file" accept="application/pdf" />
            </div>
            <div>
                <label style={{ margin: '0', padding: '0' }} htmlFor="position">Description</label>
                <textarea
                    className="form-control"
                    type="text"
                    placeholder="Description"
                    value={description}
                    onChange={e => setDescription(e.target.value)}
                    name="description"
                    style={{ padding: '7px' }}
                />
            </div>
            <div style={{ display: 'flex', justifyContent: 'end', marginTop: '10px' }}>
                <button
                    className="btn btn-success btn-sm rounded-circle"
                    disabled={name === '' || orgnization === '' || issueDate === '' || description === ''}
                    onClick={saveDetails}>
                    Add
                </button>
            </div>
        </div >
    )
}

const mapStateToProps = state => ({
    awards: state.awards,
});

const mapDispatchToProps = dispatch => ({
    onCreatePressed: award => dispatch(createAward(award)),
});

export default connect(mapStateToProps, mapDispatchToProps)(NewAwardForm);
